<form #formulario="ngForm">
    <mat-accordion>

        <mat-expansion-panel [expanded]="openFormCadastro" (closed)="openFormCadastro = false"
                             [disabled]="!perfilAcesso.altera && !perfilAcesso.insere ||
                             (!isAtualizarAluno && !perfilAcesso.insere)">
            <mat-expansion-panel-header>
                <mat-panel-title>Contratos</mat-panel-title>
            </mat-expansion-panel-header>

            <div fxLayout="row" fxFlexFill>
                <div ngModelGroup="comboContrato" fxLayoutGap="20px" fxFlex="100">
                    <combo-contrato [showDisplayId]="false"
                                    [obrigatorio]="true"
                                    [selecionado]="alunoContrato.contrato"
                                    (valorChange)="onValorChangeAluno($event)">
                    </combo-contrato>
                </div>
            </div>
            <div fxLayout="row" fxFlexFill>
                <mat-form-field fxLayoutGap="20px" fxFlexOffset="20px" fxFlex="100">
                    <mat-label>Data Início</mat-label>
                    <input matInput name="dataInicioAlunoContrato" [matDatepicker]="dataInicioAlunoContrato"
                           placeholder="Data Início" [(ngModel)]="alunoContrato.dataInicio"
                           (input)="onMascaraDataInput($event)" maxlength="10">
                    <mat-datepicker-toggle matSuffix [for]="dataInicioAlunoContrato"></mat-datepicker-toggle>
                    <mat-datepicker #dataInicioAlunoContrato></mat-datepicker>
                </mat-form-field>

                <mat-form-field fxLayoutGap="20px" fxFlexOffset="20px" fxFlex="100">
                    <mat-label>Data Fim</mat-label>
                    <input matInput name="dataFimAlunoContrato" [matDatepicker]="dataFimAlunoContrato"
                           placeholder="Data Fim" [(ngModel)]="alunoContrato.dataFim"
                           (input)="onMascaraDataInput($event)" maxlength="10">
                    <mat-datepicker-toggle matSuffix [for]="dataFimAlunoContrato"></mat-datepicker-toggle>
                    <mat-datepicker #dataFimAlunoContrato></mat-datepicker>
                </mat-form-field>
            </div>


            <div dir="rtl" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="20px"
                 style="padding-top: 20px; padding-bottom: 10px; padding-right: 20px" fxFlexFill>

                <button type="button" mat-raised-button name="botaoLimpar" fxFlex="20%" color="primary" (click)="limpar()">
                    Limpar
                </button>

                <button mat-raised-button name="botaoAdicionar" [disabled]="!alunoContrato?.contrato?.id || !perfilAcesso.insere"
                        fxFlex="20%" color="primary" (click)="adicionar()" *ngIf="!isAtualizarAluno" type="button">
                    Adicionar
                </button>
                <button mat-raised-button name="botaoAlterar" [disabled]="!alunoContrato?.aluno?.id" fxFlex="20%"
                        color="primary" (click)="alterar()" *ngIf="isAtualizarAluno" type="button">
                    Alterar
                </button>


            </div>

        </mat-expansion-panel>


        <mat-expansion-panel [expanded]="!openFormCadastro" (opened)="carregarLista()"
                             (closed)="openFormCadastro = true" [disabled]="!perfilAcesso.altera && !perfilAcesso.insere">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    Lista de Contratos ( {{ listaAlunosContrato?.length }} )
                </mat-panel-title>
            </mat-expansion-panel-header>

            <table *ngIf="mostrarTabela; else tabelaSemDados" mat-table [dataSource]="dataSource"
                   style="margin-top: 20px">

                <ng-container matColumnDef="contrato">
                    <th mat-header-cell *matHeaderCellDef> Contrato</th>
                    <td mat-cell *matCellDef="let element"> {{ element.contrato?.descricao }}</td>
                </ng-container>

                <ng-container matColumnDef="dataInicio">
                    <th mat-header-cell *matHeaderCellDef> Data início</th>
                    <td mat-cell *matCellDef="let element"> {{ element.dataInicio | dataSimples }}</td>
                </ng-container>

                <ng-container matColumnDef="dataFim">
                    <th mat-header-cell *matHeaderCellDef> Data fim</th>
                    <td mat-cell *matCellDef="let element"> {{ element.dataFim | dataSimples }}</td>
                </ng-container>

                <ng-container matColumnDef="valor">
                    <th mat-header-cell *matHeaderCellDef> Valor</th>
                    <td mat-cell *matCellDef="let element"> {{ element.valor | currency: 'BRL' }}</td>
                </ng-container>

                <ng-container matColumnDef="acoes">
                    <th mat-header-cell *matHeaderCellDef> Ações</th>
                    <td mat-cell *matCellDef="let element">
                        <button *ngIf="perfilAcesso.deleta && listaAlunosContrato?.length >= 1 &&
                                       (isAtualizar && perfilAcesso.altera || !isAtualizar && perfilAcesso.insere)" mat-button
                                (click)="deletar(element)" type="button">
                            <mat-icon>delete</mat-icon>
                        </button>
                        <button *ngIf="perfilAcesso.altera" mat-button (click)="irAtualizar(element)" type="button">
                            <mat-icon>edit</mat-icon>
                        </button>

                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>

            <div [hidden]="!mostrarTabela">
                <mat-paginator [pageSizeOptions]="[5]" showFirstLastButtons></mat-paginator>
            </div>

            <ng-template #tabelaSemDados>
                <div fxLayout="row" fxLayoutAlign="center center" style="padding-top: 10px">
                    {{ msg }}
                </div>
            </ng-template>

            <div fxLayout="row" *ngIf="(isAtualizar && perfilAcesso.altera || !isAtualizar && perfilAcesso.insere)" fxLayoutAlign="end center" fxLayoutGap="16px"
                 style="padding-top: 30px">
                <div>
                    <button type="button" matTooltip="Adicionar novo aluno" mat-fab color="primary" (click)="irNovo()">
                        <mat-icon>add</mat-icon>
                    </button>
                </div>
            </div>
        </mat-expansion-panel>

    </mat-accordion>
</form>